
// Utility for optimizing images from Supabase Storage
export interface ImageOptimizationOptions {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'webp' | 'jpg' | 'png';
}

export const optimizeSupabaseImage = (
  imageUrl: string, 
  options: ImageOptimizationOptions = {}
): string => {
  // If it's not a Supabase storage URL, return as-is
  if (!imageUrl || !imageUrl.includes('supabase')) {
    return imageUrl;
  }

  const {
    width,
    height,
    quality = 75,
    format = 'webp'
  } = options;

  // Parse the Supabase storage URL
  const url = new URL(imageUrl);
  const params = new URLSearchParams();

  // Add transformation parameters
  if (width) params.append('width', width.toString());
  if (height) params.append('height', height.toString());
  params.append('quality', quality.toString());
  params.append('format', format);

  // Add resize mode for better optimization
  params.append('resize', 'cover');

  // Construct the optimized URL
  url.search = params.toString();
  
  return url.toString();
};

// Helper for common image sizes used across the site
export const getOptimizedImageSizes = () => ({
  hero: { width: 1200, height: 600 },
  featured: { width: 800, height: 450 },
  thumbnail: { width: 300, height: 200 },
  avatar: { width: 100, height: 100 },
  icon: { width: 48, height: 48 }
});
